export default {"src":"/_next/static/media/BIRD.10aaeba5.svg","height":18,"width":18};